// RootExplorer.jsx
import React, { useMemo, useState } from "react";
import DrillList from "./DrillList";
import { GrowthPill, RowIcons, ValueSharePill } from "./MetricPills";

import "./revenue.css";
import GenericOverviewSideCard from "../genericComponents/GenericOverviewSideCard";
import { useParams } from "react-router-dom";
import RevenueChatByNode from "../Chat/RevenueChatByNode";

function RootCard({ item, dimensions, onAIClick, activeDim}) {   
  const [open, setOpen] = useState(false);

  const hasBreakdowns =
    !!item?.breakdowns && Object.keys(item.breakdowns || {}).length > 0;

  return (
    <div className="root-card">
      <div
        className="root-head"
        role="button"
        onClick={() => hasBreakdowns && setOpen(v => !v)}
      >
        <div className="label">
          {hasBreakdowns && (
            <i className={`ri-arrow-${open ? "up" : "down"}-s-line me-2 icon_down_up`} />
          )}
          {item.label}
        </div>
        <div className="right">
          <ValueSharePill value={item.value} sharePct={item.sharePct} />
          <GrowthPill growthPct={item.growthPct} />
          <RowIcons
            showAI
            onAIClick={() => onAIClick?.(item.label)}  
            sources={item.sources}
            baseFacts={item.baseFacts}
            nodeLabel={item.label}
          />
        </div>
      </div>

      {open && hasBreakdowns && (
        <div className="root-body">
          <DrillList
            node={item}
            allDims={dimensions}
            path={[activeDim]}
            depth={0}
            // showAIAtThisLevel={true}           // <-- enable AI at first drill level
            onAIClick={onAIClick}              // <-- forwards up to RootExplorer
          />
        </div>
      )}
    </div>
  );
}

const slugify = (s) => {
  if (!s) return "";
  let out = s.normalize("NFKD");                 // Unicode NFKD
  out = out.replace(/[\u0300-\u036f]/g, "");     // strip diacritics
  out = out.replace(/[^a-zA-Z0-9]+/g, "_");      // non-alnum -> _
  out = out.replace(/^_+|_+$/g, "");             // trim _
  return out.toLowerCase();
};

export default function RootExplorer({ data, activeDim }) {
  const dimensions = data?.dimensions || [];
  const rows = useMemo(() => data?.root?.[activeDim] || [], [data, activeDim]);
  const { clientName: USER_COMPANY, competitorName: COMPANY_NAME } = useParams();

  // LIFTED STATE: one modal for the whole page
  const [showConversationModal, setShowConversationModal] = useState(false);
  const [aiTarget, setAiTarget] = useState("");

  const handleAIClick = (label) => {
    setAiTarget(label);              // e.g., "United States" or "Canada"
    setShowConversationModal(true);
  };

  const fiscalYear = data?.context?.fiscalYear || null; // from RevenueTeardown
  const baseKey = `${activeDim}_${slugify(aiTarget)}`;
  const tableName =  baseKey;

  return (
    <div className="root-list">
      {rows.map((r, i) => (
        <RootCard
          key={`${activeDim}-${r.label}-${i}`}
          item={r}
          dimensions={dimensions}
          activeDim={activeDim}
          onAIClick={handleAIClick}     // <-- pass down
        />
      ))}

      {showConversationModal && (
        <GenericOverviewSideCard
          showMoreModal={showConversationModal}
          setShowMoreModal={setShowConversationModal}
          titleForSideCard={
            <div className="ai_insight_top_block">
              <div className="ai_insight_left">
                <div className="ai_insight_img">
                  <img src="/img/ai_insight_top.png" alt="icon" className="ai_icon" />
                </div>
                <div className="ai_insight_text">
                  <h5 className="ai_insight_top_head">
                    Decode This: {aiTarget}
                  </h5>
                  <p className="ai_insight_top_subhead">
                    AI-powered competitive intelligence and strategic insights
                  </p>
                </div>
              </div>
              <div className="ai_insight_right"></div>
            </div>
          }
         comp={
            <RevenueChatByNode
              USER_COMPANY={USER_COMPANY}
              COMPANY_NAME={COMPANY_NAME}
              table_name={tableName}
            />
          }
          minWidthForDrawer="40%"
          disableXbtn={false}
        />
      )}
    </div>
  );
}
